import { ApplicationConfig, provideExperimentalZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { httpInterceptor } from './core/interceptors/http-request/http-request.interceptor';
import { errorInterceptor } from './core/interceptors/http-error/http-error.interceptor';
import { AuthStore } from './core/stores/auth.store';
import { authInterceptor } from './core/interceptors/auth/auth.interceptor';

import { UiStore } from './core/stores/ui.store';
import { DetailsStore } from './core/stores/order-details.store';
import { ListStore } from './core/stores/orders-list.store';


export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([
        httpInterceptor, errorInterceptor, authInterceptor
      ]
    )),
    AuthStore,    
    DetailsStore,
    ListStore,
    UiStore

  ]
};
